<template>
    <div class="flex flex-row justify-center">
        <div class="flex flex-col">
            <div><img src="images/main-view.png" class="w-72" /></div>
            <div class="text-center">Describe your data.</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
